import { hash, obstaclesNear, type Obstacle } from './obstacles';
import type { GameState, LootMotion } from './types';

const blockers: Obstacle[] = [];

/** Czy punkt leży wewnątrz przeszkody (drzewa, grobu, skały) — pociski się o nie rozbijają. */
export function insideObstacle(s: GameState, x: number, y: number): boolean {
  const count = s.content.zones[s.zoneId]?.obstacles ?? 0;
  if (count === 0) return false;
  return obstaclesNear(s.seed, count, x, y, 0, blockers).some((o) => (o.x - x) ** 2 + (o.y - y) ** 2 < o.radius ** 2);
}

/**
 * Rozsypanie łupu: przy pierwszej klatce łup dostaje prędkość w kierunku wyliczonym z id (bez zużywania
 * nextRandom, więc reszta losowania wyprawy się nie zmienia), potem hamuje.
 */
export function scatterLoot(s: GameState, l: LootMotion & { id: number; x: number; y: number }, dt: number): void {
  const phys = s.content.game.physics;
  if (l.vx === undefined || l.vy === undefined) {
    const angle = hash(s.seed, l.id, 7, 3) * Math.PI * 2;
    const [min, max] = phys.lootScatter;
    const v = min + (max - min) * hash(s.seed, l.id, 11, 5);
    l.vx = Math.cos(angle) * v;
    l.vy = Math.sin(angle) * v;
  }
  if (l.vx === 0 && l.vy === 0) return;
  l.x += l.vx * dt;
  l.y += l.vy * dt;
  const decay = Math.exp(-phys.lootFriction * dt);
  l.vx *= decay;
  l.vy *= decay;
  if (Math.abs(l.vx) + Math.abs(l.vy) < 2) l.vx = l.vy = 0;
}

/** Magnes: łup rusza powoli i przyspiesza w stronę bohatera, aż do gemMagnetSpeed. */
export function pullLoot(s: GameState, l: LootMotion & { x: number; y: number }, dt: number): void {
  const phys = s.content.game.physics;
  const p = s.player;
  const dx = p.x - l.x;
  const dy = p.y - l.y;
  const d = Math.hypot(dx, dy);
  if (d === 0) return;
  l.pull = Math.min(s.content.game.gemMagnetSpeed, (l.pull ?? phys.magnetStartSpeed) + phys.magnetAccel * dt);
  const k = Math.min(d, l.pull * dt) / d;
  l.x += dx * k;
  l.y += dy * k;
}
